import React, { useState, useRef } from 'react';
import { Container, Menu, Icon, Card, Grid } from 'semantic-ui-react';
import { Button, Dialog, DialogTitle, DialogContent, Avatar, Typography, DialogActions, TextField, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit'; // Import the pencil icon
import PageLayout from "examples/LayoutContainers/PageLayout";
import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css'; // Import the Cropper's styles
import { shouldHideStudentLogout } from "utils/impersonationAccess";
const Navbar = () => {
    const navigate = useNavigate();
    const user = JSON.parse(sessionStorage.getItem("user"));
    const token = sessionStorage.getItem("token");
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const { organization_id } = "1";
  return (
    <>
       {/* Navbar */}
       <Menu style={{ backgroundColor: '#28166F' }} inverted>
                    <Container>
                        <Menu.Item header>
                            <Icon name='university' size='large' />
                            Admissions
                        </Menu.Item>
                        <Menu.Menu position='right'>
                            {!shouldHideStudentLogout() && (
                            <Menu.Item>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<Icon name='sign-out' />}
                                    style={{ backgroundColor: 'white', color: '#28166F' }}
                                    onClick={() => navigate(`/`)}
                                >
                                    Logout
                                </Button>
                            </Menu.Item>
                            )}
                        </Menu.Menu>
                    </Container>
                </Menu>
                {/* <Container style={{ marginTop: '2em' }}>
                    <h2 style={{ fontFamily: 'Helvetica, Arial, sans-serif', marginBottom: '1em' }}> */}
                        {/* 👋 Hi, {user.name}! */}
                        {/* 👋 Hi, {user ? user.name : "Guest"}!
                    </h2>
                </Container> */}
    </>
  )
}

export default Navbar
